import PropTypes from "prop-types";
import SourceFlowImage from "@sourceflow-uk/sourceflowimage";
import { transformImageUrl } from "@/functions/transformImageUrl";
import { getTransformedImagesMetaData } from "@/functions/getTransformedImagesMetaData";

/**
 *
 * @param className
 * @param img
 * @param size
 * @param alt
 * @returns {JSX.Element|null}
 * @constructor
 */
export default function Image({ className, img, size, alt }) {
  if (!img) {
    return null;
  }

  if (typeof img === "string") {
    return <SourceFlowImage className={className} src={transformImageUrl(img)} size={size} alt={alt} />;
  }

  if (typeof img === "object") {
    return (
      <SourceFlowImage
        className={className}
        path={img.path ?? null}
        src={transformImageUrl(img.src ?? null)}
        size={size}
        alt={alt}
        imagesMetaData={getTransformedImagesMetaData()}
      />
    );
  }

  return null;
}

Image.defaultProps = {
  className: "",
  img: null,
  size: null,
  alt: "",
};

Image.propTypes = {
  className: PropTypes.string,
  img: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      path: PropTypes.string,
      src: PropTypes.string,
    }),
  ]),
  size: PropTypes.string,
  alt: PropTypes.string,
};